import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faTwitter, faDiscord, faGithub } from '@fortawesome/free-brands-svg-icons';


interface ISocialLink {
    name: string;
    link: string;
    icon: JSX.Element;
}

const SocialLinks: ISocialLink[] = [
    {
        name: "Telegram",
        link: "https://t.me/YetiSwap",
        icon: <FontAwesomeIcon icon={faTelegram} size="1x" />
    },
    {
        name: "Twitter",
        link: "https://twitter.com/YetiSwap",
        icon: <FontAwesomeIcon icon={faTwitter} size="1x" />
    },
    {
        name: "Discord",
        link: "https://discord.com/invite/aKm7XVYzup",
        icon: <FontAwesomeIcon icon={faDiscord} size="1x" />
    },
    {
        name: "Github",
        link: "https://github.com/YetiSwap",
        icon: <FontAwesomeIcon icon={faGithub} size="1x" />
    }
]

export default SocialLinks;